import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import { Caches, TransformChartData, TransformHKChartData } from './decorator';
// import { Caches } from './decorator';

@Create({
  // baseURL: getApiHostWithoutEnv('fundmobapi'),
  baseURL: getApiHostWithoutEnv('dataapi'),
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
  // baseURL: 'https://fundmobapi.eastmoney.com',
})
class Model {
  // 动态-累计收益行情、买卖点、成本线-FundMNYieldDiagram
  @TransformChartData()
  @Caches()
  FundMNYieldDiagramAcc(publicParams, INDEXCODE, FCODE, RANGE) {
    return this.GET('/dataapi/fund/FundVPageAcc', {
    // return this.GET('/FundMNewApi/FundMNYieldDiagram', {
      INDEXCODE,
      CODE: FCODE,
      FCODE,
      RANGE,
      ...publicParams,
    }, {
      baseURL: 'https://uni-fundts.1234567.com.cn',
    });
  }

  @TransformHKChartData()
  FundMNHKYieldDiagram(publicParams, INDEXCODE, FCODE, RANGE) {
    return this.JSONP('/FundMNewApi/FundMNewHKAccSyi', {
    // https://fundmobapi.eastmoney.com/FundMApi/FundHongKongAccumulatedIncome.ashx?deviceid=hkfund2016&version=4.3.0&product=EFund&plat=Iphone&HKFCODE=968052&RANGE=M&_=1618470304105&callback=jsonp7
    // return this.GET('/FundMNewApi/FundMNYieldDiagram', {
      INDEXCODE,
      HKFCODE: FCODE,
      FCODE,
      RANGE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 单位净值、累计净值-FundMNNetHKDiagram
  @TransformHKChartData()
  @Caches()
  FundMNNetHKDiagram(publicParams, FCODE, RANGE) {
    // return this.GET('/FundMNewApi/FundMNNetDiagram', {
    return this.GET('/FundMNewApi/FundHKNetDiagram', {
      fCODE: FCODE,
      rANGE: RANGE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 单位净值、累计净值-FundMNNetDiagram
  @TransformChartData()
  @Caches()
  FundMNNetDiagram(publicParams, FCODE, RANGE) {
    // return this.GET('/FundMNewApi/FundMNNetDiagram', {dataapi
    return this.GET('/dataapi/fund/FundNetDiagram2', {
      CODE: FCODE,
      FCODE,
      RANGE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('dataapi'),
    });
  }

  // 黄金走势
  @Caches(60 * 1000)
  FundGoldDiagram(publicParams, FCODE, RANGE) {
    return this.JSONP('/FundMApi/FundGoldDiagram.ashx', {
      FCODE,
      RANGE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 净值估算
  @Caches(1000)
  FundVarietieValuationDetail(publicParams, FCODE) {
    return this.JSONP('/FundMApi/FundVarietieValuationDetail.ashx', {
      FCODE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 基金持仓-资产
  @Caches()
  FundMNAssetAllocationNew(publicParams, FCODE) {
    return this.GET('/FundMNewApi/FundMNAssetAllocationNew', {
      FCODE,
      ...publicParams,
    });
  }

  // 基金持仓-资产（货币）
  @Caches()
  FundMNInvestMoneyManagement(publicParams, FCODE) {
    return this.GET('/FundMNewApi/FundMNInvestMoneyManagement', {
      FCODE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 基金持仓-行业
  @Caches()
  FundMNSectorAllocation(publicParams, FCODE, DATE) {
    return this.JSONP('/FundMNewApi/FundMNSectorAllocation', {
      FCODE,
      DATE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 基金规模
  @Caches()
  FundMNAssetsList(publicParams, FCODE) {
    return this.GET('/FundMNewApi/FundMNAssetsList', {
      FCODE,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('fundmobapi'),
    });
  }

  // 获取用户买卖点
  @Caches(3 * 60 * 60 * 1000, (row) => row && row.Data)
  GetBuyAndSellPoint(publicParams, FundCode) {
    return this.POST('/User/home/GetBuyAndSellPoint', {
      FundCode,
      ...publicParams,
      Span: -2,
    }, {
      baseURL: getApiHostWithoutEnv('tradeapilvs', publicParams.zone),
    });
  }

  // 获取摊薄成本单价
  @Caches(3 * 60 * 60 * 1000, (row) => row && row.Data)
  GetHoldFundDetail(publicParams, FundCode) {
    return this.POST('/User/home/GetHoldFundDetail', {
      FundCode,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('tradeapilvs', publicParams.zone),
    });
  }

  // 获取新的摊薄成本单价
  @Caches(3 * 60 * 60 * 1000)
  GetHoldAndBuyFundsProfit(publicParams, FundCode) {
    return this.POST('/User/Asset/GetFundsProductProfit', {
      FundCodes: FundCode,
      UserId: publicParams.uid,
      Span: -2,
      ...publicParams,
    }, {
      baseURL: getApiHostWithoutEnv('tradeapilvs', publicParams.zone),
    });
  }
}

export default new Model();
